import React from 'react';
import { LoginForm } from './login-form';
import { InteractiveGridPattern } from './magicui/interactive-grid-pattern';

export default function LoginPage({ onLogin }) {
  return (
    <div className="min-h-screen relative overflow-hidden">
      <InteractiveGridPattern 
        width={60} 
        height={60} 
        squares={[50, 50]} 
        className="absolute inset-0 w-screen h-screen" 
      />
      <div className="relative z-10 flex flex-col gap-4 p-6 md:p-10 min-h-screen">
        <div className="flex justify-center gap-2 md:justify-start">
          <a href="#" className="flex items-center gap-2 font-medium">
            <div className="bg-primary text-primary-foreground flex size-6 items-center justify-center rounded-md">
              <svg className="size-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
              </svg>
            </div>
            BootMinds Elite
          </a>
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-xs">
            <LoginForm onLogin={onLogin} />
          </div>
        </div>
      </div>
    </div>
  );
}
